import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal, Button, Checkbox } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../assets/images/icons/chevron-right.svg';
import noData from '../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../../TableLoader";
import errorData from '../../../assets/images/data-graph/error-data.svg';
import addIcon from '../../../assets/images/icons/add.svg';
import GamAutomationCreate from "./GamAutomationCreate";
import GamAutomationViewEdit from "./GamAutomationViewEdit";
import macrosicon from '../../../assets/images/icons/macros_modal_icon.svg';
import filterIcon from '../../../assets/images/icons/add_child_icon.svg';
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";

const GamAutomationList = () => {

    const loadingContext = useContext(LoadingContext);
    const [pageView, setPageView] = useState("table")
    const [apiCall, setApicall] = useState(false)

    const [campaignViewObjectId, setCampaignViewObjectId] = useState("")
    const [campaignViewId, setCampaignViewId] = useState("")
    const [campaignViewName, setCampaignViewName] = useState("")

    const columnsAll = [
        {
            title: "Campaign Name",
            dataIndex: "campaignId",
            width: 200,
            key: "campaignId",
            fixed: 'left',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text, record) => {

                return (
                    <div >
                        {(text === "" || text === undefined || text === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {(((text?.length + record.c_name?.length) || 0)) >= 40 ? (
                                    <Tooltip title={text}>
                                        <div className='anchor_text_link_d2'
                                            onClick={() => {
                                                setCampaignViewObjectId(record._id)
                                                setCampaignViewId(record.campaignId)
                                                setCampaignViewName(record.c_name)
                                                setPageView("view");

                                            }}
                                        >
                                            {(text + record.c_name)?.slice(0, 40)} ...
                                        </div>
                                    </Tooltip>
                                ) : (

                                    <div className='anchor_text_link_d2'
                                        onClick={() => {
                                            setCampaignViewObjectId(record._id)
                                            setCampaignViewId(record.campaignId)
                                            setCampaignViewName(record.c_name)
                                            setPageView("view");
                                        }}
                                    >
                                        {text}-{record.c_name}
                                    </div>

                                )}

                            </>

                        }
                    </div>
                )
            },
        },
        {
            title: "Zone ID",
            dataIndex: "zoneId",
            width: 220,
            key: "zoneId",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {
                let zones;
                if (text === undefined || text === "") {
                    zones = []
                }
                else {
                    zones = text
                }

                return (
                    <>
                        {zones.length === 0 ?
                            <div className='text_dark'>-</div>
                            :
                            <div className="">
                                <div className="usertable_badges_d2 d_flex gap_8">

                                    {zones.length >= 1 &&
                                        <div className='table_badges--d2 --grey'>
                                            {zones[0]}
                                        </div>
                                    }
                                    {
                                        zones.length >= 2 &&
                                        <div className='table_badges--d2 --grey'>
                                            {zones[1]}
                                        </div>
                                    }
                                    {
                                        zones.length >= 3 &&
                                        <div className='table_badges--d2 --grey'>
                                            {zones[2]}
                                        </div>
                                    }
                                    {
                                        zones.length >= 4 &&
                                        <div className='table_badges--d2 --grey'>
                                            {zones[3]}
                                        </div>
                                    }
                                    {
                                        zones.length >= 5 &&
                                        <div className='table_badges--d2 --grey'>
                                            {zones[4]}
                                        </div>
                                    }
                                    {
                                        zones.length >= 6 &&
                                        <Tooltip title={zones.slice(5).join(",")}>
                                            <div className='table_badges--d2 --grey'>
                                                +{zones.length - 5}
                                            </div>
                                        </Tooltip>
                                    }
                                </div>
                            </div>
                        }
                    </>
                )
            }
        },
        {
            title: "Type",
            dataIndex: "type",
            width: 40,
            key: "type",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {
                return (
                    <>
                        {
                            text === "t1" ?
                                <>T1</>
                                :
                                <>T2</>

                        }
                    </>
                )
            }
        },
        {
            title: "Publisher",
            dataIndex: "publisher",
            width: 50,
            key: "publisher",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
        },

        {
            title: "eCPM (Min-Max)",
            dataIndex: "min_eCPM",
            width: 80,
            key: "min_eCPM",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
                return (
                    <>
                        $ {text}-{record.max_eCPM}
                    </>
                )
            }
        },
        {
            title: "VAST per child",
            dataIndex: "v_per_child",
            width: 80,
            key: "v_per_child",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text) => {
                return (
                    <>
                        {text ? <>True</> : <>False</>}
                    </>
                )
            }
        },
        {
            title: 'Ad Units',
            dataIndex: 'adUnitsArray',
            width: 50,
            key: 'adUnitsArray',
            render: (data) => {

                return (
                    <>
                        {(data?.length === 0 || data === undefined) ? <><div className='text_dark'>-</div></> :
                            <div className='anchor_text_link_d2' onClick={() => {
                                setIsModalVisibleAdUnits(true);
                                setModalAdUnits_preview(data)
                            }
                            } >View</div>
                        }
                    </>
                )

            },
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            width: 80,
            key: "createdAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Updated At",
            dataIndex: "updatedAt",
            width: 80,
            key: "updatedAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")




    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `gam_auto/campList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }

                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        // let checkRole = jwtDecode(token).role;
        // setCheckRole(checkRole)
        // }
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);


    //modal related ad units-------------------------------------

    const [modalAdUnits_Preview, setModalAdUnits_preview] = useState([]);
    const [isModalVisibleAdUnits, setIsModalVisibleAdUnits] = useState(false);

    const closeModalAdUnits = () => {
        setIsModalVisibleAdUnits(false);
        setModalAdUnits_preview([])
    };

    //---------------------------------------------------------------

    //modal related  child lists-------------------------------------

    const [isModalVisibleChild, setIsModalVisibleChild] = useState(false);

    const closeModalChild = () => {
        setIsModalVisibleChild(false);
        onChangeReset_child()
    };

    React.useEffect(() => {
        axios
            .get(configData.SERVER_URL + "gam_auto/childCodeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (response.data.data.length > 0) {
                    setChildMappingData(response.data.data);

                }

                setLoadingChildMapping(false)
            })
            .catch((error) => { setLoadingChildMapping(false) });

    }, [])

    const [loadingChildMapping, setLoadingChildMapping] = useState(true);
    const [childMappingData, setChildMappingData] = useState([])
    // const [childMappingDataIsRequiredError, setChildMappingDataIsRequiredError] = useState(false)
    const childMappingColumns = [
        {
            title: 'Child Publisher Name',
            dataIndex: 'child_pub_name',
            key: 'child_pub_name',
            width: 250,
            render: (text) =>
                text.length > 30 ?
                    <Tooltip title={text}><div className="text_dark text_ellipsis text_black_d2 d-block">{text.slice(0, 30)}...</div></Tooltip> :
                    <div className="text_dark text_ellipsis text_black_d2 d-block">{text}</div>

        },
        {
            title: 'Child Network Code',
            dataIndex: 'child_net_code',
            key: 'child_net_code',
            width: 175,

        },
        {
            title: 'DSP Domain List Id',
            dataIndex: 'child_seller_id',
            key: 'child_seller_id',
            width: 115,
        },
        {
            title: 'DSP Domain Lists',
            dataIndex: 'dsp_domain_lists',
            key: 'dsp_domain_lists',
            width: 322,
            render: (text) =>
                text.length > 40 ?
                    <Tooltip title={text}><div className="text_dark text_ellipsis text_black_d2 d-block">{text.slice(0, 40)}...</div></Tooltip> :
                    <div className="text_dark text_ellipsis text_black_d2 d-block">{text}</div>
        },

    ];

    const localeChildMapping = {
        emptyText:
            <>{
                loadingChildMapping &&
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <img src={FullLoader} width={30} height={30} alt="USP" className="" />
                    </div>
                </div>
            }
            </>

    };

    const [buttonProcessing_child, setButtonProcessing_child] = useState(false);


    function onChangeReset_child() {
        setButtonProcessing_child(false)
        setPublisherName_child("")
        setPublisherNameIsRequiredError_child(false)
        setChildNetwork_child("")
        setChildNetworkIsRequiredError_child(false)
        setChildSeller_child("")
        setChildSellerIsRequiredError_child(false)
        setDspDomain_child("")
        setDspDomainIsRequiredError_child(false)
    }

    const [publisherName_child, setPublisherName_child] = useState("");
    const [publisherNameIsRequiredError_child, setPublisherNameIsRequiredError_child] = useState(false);

    function onChangePublisherName_child(event) {
        setPublisherNameIsRequiredError_child(false)
        setPublisherName_child(event.target.value)

    }

    const [childNetwork_child, setChildNetwork_child] = useState("");
    const [childNetworkIsRequiredError_child, setChildNetworkIsRequiredError_child] = useState(false);

    function onChangeChildNetwork_child(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setChildNetworkIsRequiredError_child(false)
            setChildNetwork_child(event.target.value)
        }
    }

    const [childSeller_child, setChildSeller_child] = useState("");
    const [childSellerIsRequiredError_child, setChildSellerIsRequiredError_child] = useState(false);

    function onChangeChildSeller_child(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setChildSellerIsRequiredError_child(false)
            setChildSeller_child(event.target.value)
        }

    }

    const [dspDomain_child, setDspDomain_child] = useState("");
    const [dspDomainIsRequiredError_child, setDspDomainIsRequiredError_child] = useState(false);

    function onChangeDspDomain_child(event) {
        setDspDomainIsRequiredError_child(false)
        setDspDomain_child(event.target.value)

    }


    const handleSubmit_child = async (e) => {

        if (
            publisherName_child.trim() !== "" &&
            childNetwork_child.trim() !== "" &&
            childSeller_child.trim() !== "" &&
            dspDomain_child.trim() !== ""

        ) {
            if (
                publisherNameIsRequiredError_child === false &&
                childNetworkIsRequiredError_child === false &&
                childNetworkIsRequiredError_child === false &&
                dspDomainIsRequiredError_child === false
            ) {

                setButtonProcessing_child(true)

                let payload = {
                    childPublisherName: publisherName_child,
                    childNetworkCode: childNetwork_child,
                    childSellerId: childSeller_child,
                    dspDomainList: dspDomain_child
                }

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `gam_auto/createNewChild`, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);

                            axios
                                .get(configData.SERVER_URL + "gam_auto/childCodeList", {
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((response) => {
                                    if (response.data.data.length > 0) {
                                        setChildMappingData(response.data.data);
                                        onChangeReset_child()

                                    }

                                })
                                .catch((error) => { });

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }

                            // setButtonProcessing_child(false)
                        });
                }
            }

        }
        else {
            if (publisherName_child.trim() === "") {
                setPublisherName_child("")
                setPublisherNameIsRequiredError_child(true)
            }
            if (childNetwork_child.trim() === "") {
                setChildNetwork_child("")
                setChildNetworkIsRequiredError_child(true)
            }
            if (childSeller_child.trim() === "") {
                setChildSeller_child("")
                setChildSellerIsRequiredError_child(true)
            }

            if (dspDomain_child.trim() === "") {
                setDspDomain_child("")
                setDspDomainIsRequiredError_child(true)
            }
        }


    }




    //---------------------------------------------------------------


    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setApicall(!apiCall)
        }
        setCampaignViewObjectId("")
        setCampaignViewId("")
        setCampaignViewName("")
        setPageView(data)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = tempPage.current - 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };

    return (
        <>


            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        GAM Automation
                    </h1>

                    <div className="btn_group">
                        {!initialLoad &&
                            <>
                                <button className='btn btn_primary w_fit_content md'
                                    onClick={() => { setPageView("create") }}
                                ><span><img src={addIcon} alt='USP' /> Create New</span></button>
                            </>}
                    </div>
                </div>
                <div className="d_flex justify_content_between  mb_10">
                    <div className="form_content_block--group">
                        {!initialLoad &&
                            <Input
                                type='text'
                                className='form_control basic md search_input w_table_search'
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {

                                    if (e.target.value.trim().length === 0) {
                                        setLoading(true)
                                    }

                                    setSearch(e.target.value)
                                }}
                            />
                        }
                    </div>

                    <div className="custom_filter_design_d2 ">
                        {!initialLoad &&
                            <>
                                <div className="export_btn_hover_d2">
                                    <Button
                                        className="export_btn_d2"
                                        onClick={() => { setIsModalVisibleChild(true) }}
                                    >
                                        <img src={filterIcon} alt='' />
                                        Add Child
                                    </Button>

                                </div>
                            </>
                        }
                    </div>
                    {/* <div className="custom_filter_design_d2">


                        <div className="column_hide_unhide_d2">
                            <Dropdown className="" autoClose="outside">
                                <Dropdown.Toggle id="dropdown-autoclose-outside">
                                    <img src={columnIcon} alt="" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className="colunm_checkbox">
                                        <ul className="p-0 m-0">

                                            <li>
                                                <label htmlFor="oneone">
                                                    <input className="form-check-input" type="checkbox" id="oneone"
                                                        checked={colvis.z_cate}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.z_cate = !tempData.z_cate
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Category</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="twotwo">
                                                    <input className="form-check-input" type="checkbox" id="twotwo"
                                                        checked={colvis.invent_type}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.invent_type = !tempData.invent_type
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Inventory Type</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="three">
                                                    <input className="form-check-input" type="checkbox" id="three"
                                                        checked={colvis.p_name}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.p_name = !tempData.p_name
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Publisher</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="four">
                                                    <input className="form-check-input" type="checkbox" id="four"
                                                        checked={colvis.createdAt}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.createdAt = !tempData.createdAt
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Created At</span>
                                                </label>
                                            </li>

                                        </ul>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div> */}

                </div>
                <div className="table_content--box table_empty_screen_d2">
                    {loading && !initialLoad &&
                        <div className="table_new_loader_d2">
                            <img src={FullLoader} className="img-fluid" alt="" />
                        </div>
                    }

                    {initialLoad ?
                        <TableLoader />

                        :
                        <Table
                            columns={columnsAll}
                            pageSize={100}
                            dataSource={data}
                            onChange={handleTableChange}
                            pagination={false}
                            rowKey={(record) => record.id}
                            locale={locale}
                            scroll={{ x: 1800, y: 'calc(100vh - 27rem' }} />


                    }

                    {data.length > 0 &&
                        <Row className="custom_pagination--container">
                            <Col span={6}>
                                <div className="form_content_block--group mb_0">
                                    <Select
                                        className='form_select basic sm no_search'
                                        value={page.pageSize}
                                        onChange={handlePageSizeChange}
                                        style={{ width: 80 }}
                                        showSearch={false}
                                        options={[
                                            { value: 10, label: 10 },
                                            { value: 20, label: 20 },
                                            { value: 50, label: 50 },
                                            { value: 100, label: 100 },
                                        ]} />
                                    <label className='custom_pagination--label'>
                                        items per page
                                    </label>
                                </div>
                            </Col>
                            <Col span={6}>
                                <span className="custom_pagination--total-text">
                                    {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                </span>
                            </Col>
                            <Col span={6}>
                                <Pagination
                                    current={page.current}  // Pass individual props instead of spreading them
                                    pageSize={page.pageSize}
                                    total={page.total}
                                    onChange={handlePageChange}
                                    showSizeChanger={false}
                                    itemRender={itemRender}
                                    className="custom_pagination" />
                            </Col>
                        </Row>
                    }
                </div>
            </div>

            {pageView === "create" &&
                <GamAutomationCreate
                    handlePageViewChange={handlePageViewEdit}
                />
            }

            {pageView === "view" &&
                <GamAutomationViewEdit
                    handlePageViewChange={handlePageViewEdit}
                    campaignViewObjectId={campaignViewObjectId}
                    campaignViewId={campaignViewId}
                    campaignViewName={campaignViewName}
                />
            }


            <Modal
                className='custom_modal custom_modal_form_d2'
                visible={isModalVisibleAdUnits}
                onOk={closeModalAdUnits}
                width={1080}
                onCancel={closeModalAdUnits}
                maskClosable={false}
                title={
                    <div className='custom_modal--header'><h3 className='heading'><img src={macrosicon} alt='USP' /> Ad Units</h3>
                    </div>
                }
                closable={true}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end d-none">
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeModalAdUnits}> Discard </button>
                            <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                        </div>
                    </div>
                ]}
            >
                <div className="custom_modal--body">
                    <div className='all_macros_tag_d2 scrollable_tooltip_data_div_d2'>
                        <Row gutter={8}>
                            <>
                                {modalAdUnits_Preview?.map((item, index) => (
                                    <Col span={12} key={index}>
                                        <ul>
                                            <li>
                                                {item?.adunit_name}
                                            </li>
                                        </ul>
                                    </Col>

                                ))}
                            </>
                        </Row>

                    </div>
                </div>
            </Modal>

            <Modal
                className='custom_modal custom_modal_form_d2'
                visible={isModalVisibleChild}
                onOk={closeModalChild}
                width={1080}
                onCancel={closeModalChild}
                maskClosable={false}
                title={
                    <div className='custom_modal--header'><h3 className='heading'><img src={macrosicon} alt='USP' />
                        <span style={{ position: "relative" }}
                        >Child Lists

                            <span
                                className="child_gam_list_table_length"

                            >{childMappingData?.length}</span>
                        </span>

                    </h3>

                    </div>
                }
                closable={true}
                footer={[]}
            >
                <div className="custom_modal--body"
                >
                    <div className='all_macros_tag_d2'>
                        <div className="table_content--box  child_gam_list_table"
                            style={{ paddingLeft: "10px", width: "99%" }}
                        >
                            <Table
                                columns={childMappingColumns}
                                dataSource={childMappingData}
                                locale={localeChildMapping}
                                pagination={false}
                                scroll={{ x: '', y: 'calc(100vh - 35rem' }}
                            />



                            <div className="table_container_repeater">
                                <Row gutter={16} className='formHtml'>
                                    <Col span={7}>
                                        <div className='d-flex form_content_block--group'>
                                            <Input
                                                className={publisherNameIsRequiredError_child ? "form_control basic error br_6" : "form_control basic br_6"}
                                                value={publisherName_child}
                                                onChange={onChangePublisherName_child}
                                                placeholder="Publisher Name"
                                            />
                                        </div>
                                    </Col>
                                    <Col span={5}>
                                        <div className='d-flex form_content_block--group'>
                                            <Input
                                                className={childNetworkIsRequiredError_child ? "form_control basic error br_6" : "form_control basic br_6"}
                                                value={childNetwork_child}
                                                onChange={onChangeChildNetwork_child}
                                                placeholder="Network Code"

                                            />
                                        </div>
                                    </Col>
                                    <Col span={3}>
                                        <div className='d-flex form_content_block--group'>
                                            <Input
                                                className={childSellerIsRequiredError_child ? "form_control basic error br_6" : "form_control basic br_6"}
                                                value={childSeller_child}
                                                onChange={onChangeChildSeller_child}
                                                placeholder="Domain ID"

                                            />

                                        </div>
                                    </Col>

                                    <Col span={9}>
                                        <div className='d-flex form_content_block--group'>
                                            <Input
                                                className={dspDomainIsRequiredError_child ? "form_control basic error br_6" : "form_control basic br_6"}
                                                value={dspDomain_child}
                                                onChange={onChangeDspDomain_child}
                                                placeholder="Domain List"

                                            />

                                            <div className=' d-flex align-items-center justify-content-between'
                                                style={{ borderRadius: "6px", paddingLeft: "5px", cursor: "pointer" }}>
                                                {!buttonProcessing_child ?
                                                    <div
                                                        onClick={handleSubmit_child}

                                                    >
                                                        <svg

                                                            width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z" fill="#8952E0" />
                                                            <path d="M22.6663 11L13.4997 20.1667L9.33301 16" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />

                                                        </svg>
                                                    </div>
                                                    :

                                                    <button
                                                        className=" btn btn_primary loader text-capitalize"
                                                        style={{ height: "3.2rem", width: "3.2rem", marginTop: "0rem" }}
                                                    >
                                                        <span>Request Activation</span>
                                                        <img
                                                            src={loaderIcon}

                                                            height={15}
                                                            width={15}
                                                            alt="USP"
                                                            className="loader_icon"
                                                        />
                                                    </button>

                                                }

                                            </div>

                                        </div>

                                    </Col>
                                </Row>

                            </div>

                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default GamAutomationList;
